import React from "react";

const RewardsItem = ({
  imgUrl,
  text,
  code,
  rewardsItemHandler,
  used = false,
}) => {
  return (
    <div
      style={{
        opacity: used ? 0.5 : 1,
      }}
      onClick={rewardsItemHandler}
      className="rewards-item-container"
    >
      <div className="rewards-item-icon-container">
        <img src={imgUrl} alt="icon" />
      </div>
      <div className="rewards-item-details-container">
        <h5 className="rewards-item-primary-text">{text}</h5>
        <p className="rewards-item-secondary-text">{code}</p>
      </div>
    </div>
  );
};

export default RewardsItem;
